'use client';

import { getUtmParamsForDynamics } from '@/lib/utm-tracking';

export function useUtmTracking() {
  return getUtmParamsForDynamics();
}

